import React, { PureComponent } from 'react';
import { CustomerCardsSearchBar, RequestCardButton } from 'components/CustomerCards/CustomerCardsSearchBar';
import { CustomerCardsTable } from 'components/CustomerCards/CustomerCardsTable';
import { IPageResponse, SortDirection } from "../common/interfaces/IPageResponse";
import CustomerCardsService from '../services/customer-card.service';
import { ICustomerCard, ICustomerCardsSortFields, ICustomerCardsState, ICustomerCardType } from "../models/customer-card";
import { AuthenticationContext, CustomerPermission } from "../services/context/authentication.context";
import { ModifyCustomerCardModal } from "../components/CustomerCards/modals/ModifyCustomerCard/ModifyCustomerCardModal";
import { ChangeCustomerCardInfoModal } from '../components/CustomerCards/modals/ChangeCustomerCardInfo/ChangeCustomerCardInfoModal';
import { IdCreditRequestModal } from 'components/CustomerCards/modals/id-credit-request/IdCreditRequestModal';
import {CreditApplicationModal} from '../components/CustomerCards/modals/CreditApplicationModal';
import SigningModal from 'components/Modals/SigningModal/SigningModal';
import CustomerCardPinContent from 'components/CustomerCards/CustomerCardPinContent';
import CustomerCardActivateContent from 'components/CustomerCards/CustomerCardActivateContent';
import { SwitchButton, SwitchButtonState } from 'components/SwitchButton/SwitchButton';
import { SigningAction } from 'models/signing';
import { InfoCard } from 'components/InfoCard/InfoCard';
import { BlockingApplication, blockingApplicationNotice, CustomerApplicationType } from 'models/customer-application';


export class CustomerCards extends PureComponent<any, ICustomerCardsState> {

    static contextType = AuthenticationContext;

    constructor(props: any) {
        super(props);
        this.state = {
            customerId: null,
            currentTableView: ICustomerCardType.PAYMENT_CARD,
            discountCards: null,
            paymentCards: null,
            nonActivatedCards: null,
            showBlockedCards: false,
            cardCounts: { discountCards: null, paymentCards: null },
            pageRequest: {
                page: 0,
                size: 20,
                sortDirection: SortDirection.ASC,
                sortField: ICustomerCardsSortFields.REMOTE_CARD_ID,
                isBlockedCard: false,
                isActivated: true,
            },
            nonActivatedPageRequest: {
                page: 0,
                size: 999,
                sortDirection: SortDirection.ASC,
                sortField: ICustomerCardsSortFields.REMOTE_CARD_ID,
                isActivated: false,
            },
            isNewCardModalVisible: false,
            isChangeCustomerCardModalVisible: false,
            isViewPinModalVisible: false,
            isIdCreditCardModalVisible: false,
            selectedCustomerCard: null,
            isRequesting: false,
            isRequestingNonActivated: false,
            isCreditApplicationModalVisible: false,
            selectedCardNumbers: [],
            isActivateModalVisible: false,
        };
        this.props.onLoadValidatePage();
    }

    getCustomerCards = (cardType: ICustomerCardType) => {
        if (this.state.customerId === null)
            return;

        this.setState({ isRequesting: true });

        CustomerCardsService.getCustomerCards(this.state.customerId, cardType, this.state.pageRequest).then((response: IPageResponse<ICustomerCard>) => {
            this.setState({ isRequesting: false });
            if (cardType === ICustomerCardType.PAYMENT_CARD) {
                if (this.state.cardCounts.paymentCards !== null) {
                    if (this.state.pageRequest.isBlockedCard === true && this.state.cardCounts.paymentCards.disabled === null) {
                        this.setState({
                            cardCounts: {
                                ...this.state.cardCounts,
                                paymentCards: {
                                    active: this.state.cardCounts.paymentCards.active,
                                    disabled: response.totalElements
                                }
                            }
                        });
                    }
                    if (!this.state.pageRequest.isBlockedCard && this.state.cardCounts.paymentCards.active === null) {
                        this.setState({
                            cardCounts: {
                                ...this.state.cardCounts,
                                paymentCards: {
                                    active: response.totalElements,
                                    disabled: this.state.cardCounts.paymentCards.disabled
                                }
                            }
                        });
                    }
                } else {
                    if (!this.state.pageRequest.isBlockedCard) {
                        this.setState({
                            cardCounts: {
                                ...this.state.cardCounts,
                                paymentCards: {
                                    active: response.totalElements,
                                    disabled: null
                                }
                            }
                        });
                    }
                }
                this.setState({
                    paymentCards: response,
                });
            } else {
                if (this.state.cardCounts.discountCards !== null) {
                    if (this.state.pageRequest.isBlockedCard === true && this.state.cardCounts.discountCards.disabled === null) {
                        this.setState({
                            cardCounts: {
                                ...this.state.cardCounts,
                                discountCards: {
                                    active: this.state.cardCounts.discountCards.active,
                                    disabled: response.totalElements
                                }
                            }
                        });
                    }
                    if (!this.state.pageRequest.isBlockedCard && this.state.cardCounts.discountCards.active === null) {
                        this.setState({
                            cardCounts: {
                                ...this.state.cardCounts,
                                discountCards: {
                                    active: response.totalElements,
                                    disabled: this.state.cardCounts.discountCards.disabled
                                }
                            }
                        });
                    }
                } else {
                    if (!this.state.pageRequest.isBlockedCard) {
                        this.setState({
                            cardCounts: {
                                ...this.state.cardCounts,
                                discountCards: {
                                    active: response.totalElements,
                                    disabled: null
                                }
                            }
                        });
                    }
                }

                this.setState({
                    discountCards: response,
                });
            }
        });
    };

    getNonActivatedCards = () => {
        if (!this.state.customerId) return;

        this.setState({ isRequestingNonActivated: true });

        CustomerCardsService.getCustomerCards(this.state.customerId, ICustomerCardType.PAYMENT_CARD, this.state.nonActivatedPageRequest).then((response: IPageResponse<ICustomerCard>) => {
            this.setState({
                isRequestingNonActivated: false,
                nonActivatedCards: response,
            });
        });
    };

    onPageChange = (targetPage: number) => {
        if (this.state.pageRequest.page !== targetPage - 1) {
            this.setState({
                ...this.state,
                pageRequest: {
                    ...this.state.pageRequest,
                    page: targetPage - 1
                }
            }, () => {
                this.getCustomerCards(this.state.currentTableView);
            });
        }
    };

    handleTypeChange = (cardType: ICustomerCardType) => {
        this.setState({
            currentTableView: cardType,
        }, () => {
            this.setState({
                pageRequest: {
                    ...this.state.pageRequest,
                    page: 0
                },
                nonActivatedPageRequest: {
                    ...this.state.nonActivatedPageRequest,
                    page: 0
                }
            }, () => {
                this.getCustomerCards(this.state.currentTableView);
                if (ICustomerCardType.PAYMENT_CARD === cardType) this.getNonActivatedCards();
            });
        });
    };

    handleSearchQueryChange = (searchQuery?: string) => {
        this.setState((lastState: ICustomerCardsState) => ({
            pageRequest: {
                ...lastState.pageRequest,
                searchQuery: searchQuery,
                page: 0
            },
            nonActivatedPageRequest: {
                ...lastState.nonActivatedPageRequest,
                searchQuery: searchQuery,
                page: 0
            }
        }), () => {
            this.getCustomerCards(this.state.currentTableView);
            this.getNonActivatedCards();
            const otherType = this.state.currentTableView === ICustomerCardType.PAYMENT_CARD ?
                ICustomerCardType.DISCOUNT_CARD : ICustomerCardType.PAYMENT_CARD;
            this.getCustomerCards(otherType);
        });
    };


    componentDidMount(): void {
        this.getCustomerCards(ICustomerCardType.PAYMENT_CARD);
        this.getCustomerCards(ICustomerCardType.DISCOUNT_CARD);
        this.getNonActivatedCards();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<ICustomerCardsState>, snapshot?: any): void {
        if (this.context.state.customerId !== this.state.customerId) {
            this.setState({
                ...this.state,
                customerId: this.context.state.customerId,
                cardCounts: {
                    paymentCards: null,
                    discountCards: null
                },
                pageRequest: {
                    ...this.state.pageRequest,
                    page: 0
                }
            }, () => {
                this.getCustomerCards(ICustomerCardType.PAYMENT_CARD);
                this.getCustomerCards(ICustomerCardType.DISCOUNT_CARD);
                this.getNonActivatedCards();
            });
        }
    }

    requestNewCard = (cardType: ICustomerCardType) => {
        this.setState({
            newCardType: cardType,
            isNewCardModalVisible: true
        });
    };

    requestCredit = () => {
        this.setState({isCreditApplicationModalVisible: true});
    }

    /** The application type the request button on the current tab would create. */
    currentApplicationType = (hasCreditAgreement: boolean): CustomerApplicationType => {
        if (this.state.currentTableView === ICustomerCardType.DISCOUNT_CARD) {
            return CustomerApplicationType.DISCOUNT_CARD_APPLICATION;
        }

        return hasCreditAgreement
            ? CustomerApplicationType.PAYMENT_CARD_APPLICATION
            : CustomerApplicationType.CREDIT_APPLICATION;
    }

    renderRequestButton = (hasCreditAgreement: boolean, isBlocked: boolean) => {
        if (this.state.currentTableView === ICustomerCardType.DISCOUNT_CARD) {
            return <RequestCardButton
                title="Telli uus sooduskaart"
                onClick={() => this.requestNewCard(ICustomerCardType.DISCOUNT_CARD)}
                disabled={isBlocked}
            />;
        }

        if (!hasCreditAgreement) {
            return <RequestCardButton
                title="Taotle krediiti"
                onClick={this.requestCredit}
                disabled={isBlocked}
            />;
        }

        return <RequestCardButton
            title="Telli uus krediitkaart"
            onClick={() => this.requestNewCard(ICustomerCardType.PAYMENT_CARD)}
            disabled={isBlocked}
        />;
    }

    newCardModalHide = () => {
        this.setState({
            isNewCardModalVisible: false
        });
    };

    creditApplicationModalHide = () => {
        this.setState({
            isCreditApplicationModalVisible: false
        });
    };

    requestIdCreditCard = () => {
        this.setState({
            isIdCreditCardModalVisible: true
        });
    };

    idCreditCardModalHide = () => {
        this.setState({
            isIdCreditCardModalVisible: false
        });
    }

    changeCardLimitModalHide = () => {
        this.setState({
            isChangeCustomerCardModalVisible: false,
            selectedCustomerCard: null
        });
    };

    viewPinModalHide = () => {
        this.setState({
            isViewPinModalVisible: false,
            selectedCustomerCard: null,
        });
    };

    onCardEdit = (customerCard: ICustomerCard) => {
        this.setState({
            selectedCustomerCard: customerCard,
            isChangeCustomerCardModalVisible: true
        });
    }

    onViewPin = (customerCard: ICustomerCard) => {
        this.setState({
            selectedCustomerCard: customerCard,
            isViewPinModalVisible: true
        });
    }

    onCardSelect = (remoteCardId: string) => {
        this.setState((prevState) => {
            const selected = prevState.selectedCardNumbers;
            if (selected.includes(remoteCardId)) {
                return { selectedCardNumbers: selected.filter(id => id !== remoteCardId) };
            }
            return { selectedCardNumbers: [...selected, remoteCardId] };
        });
    };

    onSelectAll = () => {
        this.setState((prevState) => {
            const allCardNumbers = prevState.nonActivatedCards?.content.map(c => c.remoteCardId) ?? [];
            if (prevState.selectedCardNumbers.length === allCardNumbers.length) {
                return { selectedCardNumbers: [] };
            }
            return { selectedCardNumbers: allCardNumbers };
        });
    };

    onActivateSelected = () => {
        this.setState({ isActivateModalVisible: true });
    };

    onCardActivate = (customerCard: ICustomerCard) => {
        this.setState({
            selectedCardNumbers: [customerCard.remoteCardId],
            isActivateModalVisible: true,
        });
    };

    activateModalHide = () => {
        this.setState({
            isActivateModalVisible: false,
            selectedCardNumbers: [],
        });
    };

    onBlockedSwitchChange = (active: SwitchButtonState) => {
        this.setState((lastState: ICustomerCardsState) => ({
            pageRequest: {
                ...lastState.pageRequest,
                isBlockedCard: active === SwitchButtonState.LEFT ? false : true,
                page: 0
            }
        }), () => {
            this.getCustomerCards(this.state.currentTableView);
            const otherType = this.state.currentTableView === ICustomerCardType.PAYMENT_CARD ?
                ICustomerCardType.DISCOUNT_CARD : ICustomerCardType.PAYMENT_CARD;
            this.getCustomerCards(otherType);
        });
    };

    render() {
        const currentCards = this.state.currentTableView === ICustomerCardType.PAYMENT_CARD ?
            this.state.paymentCards : this.state.discountCards;

        const paymentCardsCount = (this.state.paymentCards ? this.state.paymentCards.totalElements : 0) + (this.state.nonActivatedCards ? this.state.nonActivatedCards.totalElements : 0);
        const discountCardsCount = this.state.discountCards ? this.state.discountCards.totalElements : 0;

        const hasCreditAgreement = !!this.context.state.customer?.hasCreditAgreement;
        const blockingApplication: BlockingApplication | undefined = this.context.state.customer
            ?.blockingApplications?.[this.currentApplicationType(hasCreditAgreement)];

        const isWebAdmin = this.context.hasPermission(CustomerPermission.WEB_ADMIN);

        return (
            <div className="customer-cards__container">
                <CustomerCardsSearchBar
                    paymentCardCount={paymentCardsCount}
                    discountCardCount={discountCardsCount}
                    onTypeChange={this.handleTypeChange}
                    onSearchQueryChange={this.handleSearchQueryChange}
                    requestButton={isWebAdmin && this.renderRequestButton(hasCreditAgreement, !!blockingApplication)}
                />
                {
                    isWebAdmin && !!blockingApplication && (
                        <InfoCard
                            text={blockingApplicationNotice([blockingApplication])}
                            variant='warning'
                            className='info-card--under-search-bar align-self-end mb-3'
                        />
                    )
                }
                {
                    this.state.nonActivatedCards?.content.length && this.state.currentTableView === ICustomerCardType.PAYMENT_CARD ? (
                        <>
                            <h2>Tellitud</h2>
                            <CustomerCardsTable
                                customerCards={this.state.nonActivatedCards}
                                onCardEdit={this.onCardEdit}
                                onViewPin={this.onViewPin}
                                onCardActivate={this.onCardActivate}
                                isRequesting={this.state.isRequestingNonActivated}
                                activated={false}
                                selectedCardNumbers={this.state.selectedCardNumbers}
                                onCardSelect={this.onCardSelect}
                                onSelectAll={this.onSelectAll}
                            />
                            {this.state.selectedCardNumbers.length > 1 && (
                                <div className='mt-1'>
                                    <button
                                        className="button-action"
                                        onClick={this.onActivateSelected}
                                    >
                                        Aktiveeri ({this.state.selectedCardNumbers.length})
                                    </button>
                                </div>
                            )}
                        </>
                    ) : null
                }
                <div className="d-flex justify-content-between">
                    <SwitchButton
                            className="ml-auto customer-cards__blocked-switch d-xl-flex d-none"
                            onActiveChange={this.onBlockedSwitchChange}
                            labelLeft={"Aktiivsed"}
                            labelRight={"Blokeeritud"}
                            active={this.state.showBlockedCards ? SwitchButtonState.RIGHT : SwitchButtonState.LEFT}
                        />                   
                </div>
                <CustomerCardsTable
                    customerCards={currentCards}
                    onPageChange={this.onPageChange}
                    onCardEdit={this.onCardEdit}
                    onViewPin={this.onViewPin}
                    isRequesting={this.state.isRequesting}
                    activated
                />
                {
                    this.state.isNewCardModalVisible &&
                    this.state.newCardType &&
                    <ModifyCustomerCardModal
                        handleModalHide={this.newCardModalHide}
                        selectedCardType={this.state.newCardType} />
                }
                {
                    this.state.isCreditApplicationModalVisible &&
                    <CreditApplicationModal
                        handleModalHide={this.creditApplicationModalHide}/>
                }
                {
                    this.state.isChangeCustomerCardModalVisible &&
                    <ChangeCustomerCardInfoModal
                        handleModalHide={this.changeCardLimitModalHide}
                        onSubmitSuccess={() => {
                            this.getCustomerCards(this.state.selectedCustomerCard?.cardType!)
                        }}
                        selectedCard={this.state.selectedCustomerCard} />
                }
                {
                    this.state.isIdCreditCardModalVisible &&
                    <IdCreditRequestModal 
                        handleConfirmSubmit={this.idCreditCardModalHide}
                        handleConfirmReject={this.idCreditCardModalHide}
                    />
                }
                {
                    this.state.isViewPinModalVisible &&
                        <SigningModal
                            handleModalHide={this.viewPinModalHide}
                            payload={{cardNumber: this.state.selectedCustomerCard!.remoteCardId}}
                            action={SigningAction.VIEW_PIN}
                            title="PINi vaatamine"
                            submitLabel="Vaata PINi"
                            savingLabel="PINi vaatamine…"
                            renderContent={(signingSessionId, onReset) => (
                                <CustomerCardPinContent
                                    signingSessionId={signingSessionId}
                                    remoteCardId={this.state.selectedCustomerCard!.remoteCardId}
                                    onExpired={onReset}
                                />
                            )}
                        />
                }
                {
                    this.state.isActivateModalVisible && this.state.selectedCardNumbers.length > 0 &&
                        <SigningModal
                            handleModalHide={this.activateModalHide}
                            payload={{cardNumbers: this.state.selectedCardNumbers}}
                            action={SigningAction.ACTIVATE_CARDS}
                            title={this.state.selectedCardNumbers.length === 1 ? "Kaardi aktiveerimine" : "Kaartide aktiveerimine"}
                            submitLabel="Aktiveeri"
                            savingLabel="Aktiveerimine…"
                            renderContent={(signingSessionId) => (
                                <CustomerCardActivateContent
                                    signingSessionId={signingSessionId}
                                    cardNumbers={this.state.selectedCardNumbers}
                                    onSuccess={() => {
                                        this.getCustomerCards(ICustomerCardType.PAYMENT_CARD);
                                        this.getNonActivatedCards();
                                    }}
                                    handleModalHide={this.activateModalHide}
                                />
                            )}
                        />
                }
            </div>
        );
    }
}